/* this file added by Bearer Web Developer  */
import { useAppState } from '../../../states/app-state';
import { useThemeMode } from '../../../states/contexts/theme';
import BusinessName from './businessName';
import DataNumber from './dataNumber';
import ExpireTime from './expireTime';
import styles from './orderData.module.scss';
import Pickup from './pickup';
import Price from './price';
import Time from './time';
interface Props {
    disabled?: boolean
}
const OrderData: React.FC<Props> = ({ disabled }) => {
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    const appState = useAppState();
    const activeManageOrder = appState?.ReservedOrders?.activeManageOrder;
    const { earliest_pickup_time, is_time_sensitive_order } = activeManageOrder!;
    const earliest = earliest_pickup_time && is_time_sensitive_order;
    return (
        <div className={`${styles.order_data} ${disabled ? styles.disabled : ''}`} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            <div className={styles.prcie_time}>
                <Price />
                {earliest ? <DataNumber /> : <Time />}
            </div>
            {
                earliest ? <Pickup /> :
                    <div className={styles.data_time}>
                        <DataNumber />
                        <ExpireTime />
                    </div>
            }
            {activeManageOrder?.shopify_order_url && <BusinessName />}
        </div>
    )
}
export default OrderData;